import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46c90ba8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "player-name-text" }
const _hoisted_3 = { class: "clock-text" }
const _hoisted_4 = { class: "player-name-text" }
const _hoisted_5 = { class: "clock-text" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["onClick", "onContextmenu"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "frame",
      style: _normalizeStyle(_ctx.layout.frame.style),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickFrame()))
    }, [
      _createElementVNode("div", {
        class: "board",
        style: _normalizeStyle(_ctx.layout.board.style)
      }, [
        _createElementVNode("img", {
          class: "board-image",
          src: _ctx.layout.board.imagePath
        }, null, 8, _hoisted_1)
      ], 4),
      _createElementVNode("div", {
        class: _normalizeClass(["player-name", { active: _ctx.position.color == 'black' }]),
        style: _normalizeStyle(_ctx.layout.blackPlayerName.style)
      }, [
        _createElementVNode("span", _hoisted_2, "▲" + _toDisplayString(_ctx.blackPlayerName), 1)
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass(["clock", _ctx.blackPlayerTimeSeverity]),
        style: _normalizeStyle(_ctx.layout.blackClock.style)
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.blackPlayerTimeText), 1)
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass(["player-name", { active: _ctx.position.color == 'white' }]),
        style: _normalizeStyle(_ctx.layout.whitePlayerName.style)
      }, [
        _createElementVNode("span", _hoisted_4, "△" + _toDisplayString(_ctx.whitePlayerName), 1)
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass(["clock", _ctx.whitePlayerTimeSeverity]),
        style: _normalizeStyle(_ctx.layout.whiteClock.style)
      }, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.whitePlayerTimeText), 1)
      ], 6),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.square, (square) => {
        return (_openBlock(), _createElementBlock("div", {
          key: square.id,
          class: "square",
          style: _normalizeStyle(square.backgroundStyle)
        }, null, 4))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.piece, (piece) => {
        return (_openBlock(), _createElementBlock("div", {
          key: piece.id,
          class: "piece",
          style: _normalizeStyle(piece.style)
        }, [
          _createElementVNode("img", {
            class: "piece-image",
            src: piece.imagePath
          }, null, 8, _hoisted_6)
        ], 4))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.square, (square) => {
        return (_openBlock(), _createElementBlock("div", {
          key: square.id,
          class: "square",
          style: _normalizeStyle(square.style),
          onClick: ($event: any) => (_ctx.clickSquare($event, square.file, square.rank)),
          onContextmenu: ($event: any) => (_ctx.clickSquareR($event, square.file, square.rank))
        }, null, 44, _hoisted_7))
      }), 128)),
      _createElementVNode("div", {
        class: "hand",
        style: _normalizeStyle(_ctx.layout.blackHand.style)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.blackHand.pointers, (pointer) => {
          return (_openBlock(), _createElementBlock("div", {
            key: pointer.id,
            class: "hand-pointer",
            style: _normalizeStyle(pointer.backgroundStyle)
          }, null, 4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.blackHand.pieces, (piece) => {
          return (_openBlock(), _createElementBlock("div", {
            key: piece.id,
            class: "piece",
            style: _normalizeStyle(piece.style)
          }, [
            _createElementVNode("img", {
              class: "piece-image",
              src: piece.imagePath
            }, null, 8, _hoisted_8)
          ], 4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.blackHand.pointers, (pointer) => {
          return (_openBlock(), _createElementBlock("div", {
            key: pointer.id,
            class: "hand-pointer",
            style: _normalizeStyle(pointer.style),
            onClick: ($event: any) => (_ctx.clickHand($event, 'black', pointer.type))
          }, null, 12, _hoisted_9))
        }), 128))
      ], 4),
      _createElementVNode("div", {
        class: "hand",
        style: _normalizeStyle(_ctx.layout.whiteHand.style)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.whiteHand.pointers, (pointer) => {
          return (_openBlock(), _createElementBlock("div", {
            key: pointer.id,
            class: "hand-pointer",
            style: _normalizeStyle(pointer.backgroundStyle)
          }, null, 4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.whiteHand.pieces, (piece) => {
          return (_openBlock(), _createElementBlock("div", {
            key: piece.id,
            class: "piece",
            style: _normalizeStyle(piece.style)
          }, [
            _createElementVNode("img", {
              class: "piece-image",
              src: piece.imagePath
            }, null, 8, _hoisted_10)
          ], 4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.whiteHand.pointers, (pointer) => {
          return (_openBlock(), _createElementBlock("div", {
            key: pointer.id,
            class: "hand-pointer",
            style: _normalizeStyle(pointer.style),
            onClick: ($event: any) => (_ctx.clickHand($event, 'white', pointer.type))
          }, null, 12, _hoisted_11))
        }), 128))
      ], 4),
      (_ctx.layout.promotion)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "promotion-selector",
            style: _normalizeStyle(_ctx.layout.promotion.style)
          }, [
            _createElementVNode("div", {
              class: "select-button promote",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickPromote($event)))
            }, [
              _createElementVNode("img", {
                class: "piece-image",
                src: _ctx.layout.promotion.promoteImagePath
              }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", {
              class: "select-button not-promote",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickNotPromote($event)))
            }, [
              _createElementVNode("img", {
                class: "piece-image",
                src: _ctx.layout.promotion.notPromoteImagePath
              }, null, 8, _hoisted_13)
            ])
          ], 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "turn",
        style: _normalizeStyle(_ctx.layout.turn.style)
      }, "手番", 4),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.layout.control.left.style)
      }, [
        _renderSlot(_ctx.$slots, "left-control", {}, undefined, true)
      ], 4),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.layout.control.right.style)
      }, [
        _renderSlot(_ctx.$slots, "right-control", {}, undefined, true)
      ], 4)
    ], 4)
  ]))
}